module.exports = "<corporates-page></corporates-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appCustomers/corporates.html
// module id = 1267
// module chunks = 0